export default {
  address: 'Adresse',
  contact: 'Kontakt',
  terms: 'Nutzungsbedingungen',
  privacy_policy: 'Datenschutzerklärung',
  impressum: 'Impressum',
  cookie_policy: 'Cookie Policy',
};
